<section class="w-100 login-screen d-flex background-grey justify-content-center align-items-center" appScrollTop>
    <div class="d-flex login h-100 p-4">
        <app-back-button class="back-button">BACK</app-back-button>
        <mat-card appearance="outlined" class="login-form-container sticky-top-10 px-3 px-sm-5 py-5 login-card">
            <div class="d-flex justify-content-center login-logo mb-3">
                <app-facility-logo class="logo" [width]="widthLogo" [height]="heightLogo"></app-facility-logo>
            </div>
            @if (!hideTitle) {
                <h1 class="foreground-primary-default mat-headline-4 text-center m-0 mt-3 mb-1">SprintPay login</h1>
            }
            <ng-content select="[login-verbiage]" />
            <app-login-form [sourceSignUp]="sourceSignUp" />
            @if (urlAdministrativeLogin) {
                <a
                    matButton="outlined"
                    color="primary"
                    [href]="urlAdministrativeLogin | sanitize: 'url'"
                    target="_blank"
                    class="btn-administrative mt-4 p-0 border-2 w-100"
                    >ADMINISTRATIVE LOGIN
                </a>
            }
        </mat-card>
    </div>
</section>
